import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 - 独家爆料",
    description:
      "你访问的页面不存在或已调整。可以返回独家爆料首页，或前往热点总览按分类与关键词查找在跟的事件时间线。",
    keywords: "独家爆料,热点总览,页面不存在",
    canonicalPath: "/",
  });

  return (
    <section className="max-w-shell mx-auto px-4 md:px-6 py-20 md:py-28">
      <div className="flex flex-col items-center text-center gap-4">
        <span className="font-heading text-6xl md:text-8xl font-black text-background-300 select-none">
          404
        </span>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          这条时间线暂时找不到
        </h1>
        <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
          你访问的地址不存在，或对应事件已被合并到其他专题。当前路径：
          <span className="ml-1 text-foreground-800 break-all">{location.pathname}</span>
        </p>
        <div className="mt-3 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/events"
            className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览热点总览
          </Link>
        </div>
      </div>
    </section>
  );
}